import React from 'react';
import AdvanceCarePlanning from '../homepage/advance-care-planning';
import UserProfileCard from '../user-profile-card';
import SharedWithNOK from './components/share-with-nok';

const Analytics = () => {
  return (
    <div className="govuk-width-container analytics mt-3">
      <UserProfileCard />
      <AdvanceCarePlanning
        title="Analytics - Advance Care Planning"
        showExtraContent
      />
      <SharedWithNOK />
    </div>
  );
};

export default Analytics;
